import axios from "axios";
import authHeader from "../auth-header";
import { PROTOCOL, URL } from "../../utils/constants";

const API_URL = `${PROTOCOL}://${URL}/api/config`;

export const getEmailConfig = () => {
  return axios.get(`${API_URL}/send-email`, { headers: authHeader() });
};

export const setEmailSendConfig = (config) => {
  return axios.put(`${API_URL}/send-email`, config, { headers: authHeader() });
};

export const sendPriceEmail = (date) => {
  const PRICE_URL = `${PROTOCOL}://${URL}/okapi/mibui/stt/resendEmail`;
  const paramRequest = date
    ? {
        datestr: date instanceof Date ? date.toISOString().split("T")[0] : date,
      }
    : undefined;
  return axios.post(PRICE_URL, paramRequest ? { paramRequest } : {}, {
    headers: authHeader(),
  });
};
